if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/* HARDDROP conversion test 2026-09 */
document.addEventListener('DOMContentLoaded', function () {
  var main = document.querySelector('[id^="MainProduct-"]');
  if (!main) return;

  var heroCopy = main.querySelector('.hd-hero-copy');
  if (heroCopy) heroCopy.innerHTML = 'Made to Order · Premium DTF Print · eigene Produktion';

  var oldInfo = main.querySelector('.additional__inf__container');
  if (oldInfo) oldInfo.style.display = 'none';

  var form = main.querySelector('product-form');
  if (form && !main.querySelector('.hd-buy-trust')) {
    var trust = document.createElement('div');
    trust.className = 'hd-buy-trust';
    trust.innerHTML = '<div>✓ Eigene Produktion</div><div>✓ Versand nach 3 Werktagen</div><div>✓ 30 Tage Rückgaberecht</div><strong>Kostenloser Versand innerhalb Deutschlands ab 79 €</strong>';
    form.insertAdjacentElement('afterend', trust);
  }

  var fit = main.querySelector('.hd-fit-note');
  if (fit && !fit.querySelector('.hd-size-link')) {
    var sizeLink = document.createElement('button');
    sizeLink.type = 'button';
    sizeLink.className = 'hd-size-link';
    sizeLink.textContent = 'GRÖSSENTABELLE ANZEIGEN';
    sizeLink.addEventListener('click', function () {
      var candidates = Array.from(document.querySelectorAll('button,a,[role="tab"]'));
      var target = candidates.find(function (el) { return (el.textContent || '').trim().toUpperCase().includes('FIT & GRÖSSE'); });
      if (target) {
        target.click();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    fit.appendChild(sizeLink);
  }

  var style = document.createElement('style');
  style.textContent = `
    #${main.id} .hd-hero-copy{font-size:12px!important;letter-spacing:.04em!important;text-transform:uppercase!important;color:#bdbdbd!important;margin:0 0 14px!important}
    #${main.id} .hd-buy-trust{margin:12px 0 10px;padding:14px 15px;border:1px solid #303030;background:#111;display:grid;gap:6px;color:#ddd;font-size:11px;line-height:1.35}
    #${main.id} .hd-buy-trust strong{margin-top:5px;padding-top:9px;border-top:1px solid #2a2a2a;color:#fff;font-size:11px;letter-spacing:.03em}
    #${main.id} .hd-size-link{display:inline-flex;margin-top:10px;padding:0;border:0;border-bottom:1px solid #777;background:transparent;color:#fff;font-size:10px;font-weight:900;letter-spacing:.1em;cursor:pointer}
    @media(max-width:989px){
      .product-sticky-form-content{display:flex!important;min-width:0!important;align-items:center!important}
      .product-sticky-form{background:#090909!important;border-top:1px solid #333!important;padding:8px 10px!important;box-shadow:0 -8px 24px rgba(0,0,0,.35)!important}
      .product-sticky-form .container{display:flex!important;align-items:center!important;gap:10px!important;flex-direction:row!important}
      .product-sticky-form-wrap{flex:1 1 auto!important;width:auto!important;padding-left:0!important}
      .product-sticky-form .product-sticky-submit{width:auto!important;min-width:160px!important;min-height:48px!important;height:auto!important;background:#fa1111!important;color:#fff!important;font-weight:900!important;letter-spacing:.07em!important}
      .product-sticky-form-content img{width:42px!important;height:52px!important;object-fit:cover!important}
      .product-sticky-form-content .product-sticky-title,.product-sticky-form-content .product-title{color:#fff!important;font-size:10px!important;line-height:1.15!important;text-transform:uppercase!important}
      .product-sticky-form-content .price,.product-sticky-form-content .money{color:#fff!important;font-size:11px!important;font-weight:900!important}
    }
  `;
  document.head.appendChild(style);
});

/* HARDDROP availability repair 2026-09-09 */
(function () {
  function getMain(sectionId) {
    return document.getElementById('MainProduct-' + sectionId) || document.querySelector('[id^="MainProduct-"]');
  }

  function normalizeAvailability(main) {
    if (!main) return null;
    var wrapper = main.querySelector('.stock-text__wrapper');
    if (!wrapper) return null;

    if (wrapper.dataset.hdAvailabilityReady === 'true') {
      return wrapper.querySelector('[data-hd-availability-status]');
    }

    var inEl = wrapper.querySelector('.in-stock__text');
    var outEl = wrapper.querySelector('.out-stock__text');
    if (!inEl && !outEl) return null;

    var inHtml = '<span>WIRD NACH BESTELLUNG PRODUZIERT</span>';
    var outHtml = '<span>AKTUELL NICHT VERFÜGBAR</span>';
    var inColor = inEl ? inEl.style.color : '';
    var outColor = outEl ? outEl.style.color : '';
    var addButton = main.querySelector('.product-form__submit[name="add"]');
    var available = !!(addButton && !addButton.disabled);

    var status = document.createElement('p');
    status.setAttribute('data-hd-availability-status', 'true');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.className = 'stock-text hd-availability-status ' + (available ? 'in-stock__text' : 'out-stock__text');
    status.innerHTML = available ? inHtml : outHtml;
    status.style.color = available ? inColor : outColor;

    wrapper.dataset.hdInHtml = inHtml;
    wrapper.dataset.hdOutHtml = outHtml;
    wrapper.dataset.hdInColor = inColor;
    wrapper.dataset.hdOutColor = outColor;
    wrapper.dataset.hdAvailabilityReady = 'true';
    wrapper.replaceChildren(status);
    return status;
  }

  function setAvailability(sectionId, available) {
    var main = getMain(sectionId);
    if (!main) return;
    var wrapper = main.querySelector('.stock-text__wrapper');
    var status = normalizeAvailability(main);
    if (!wrapper || !status) return;

    status.classList.toggle('in-stock__text', available);
    status.classList.toggle('out-stock__text', !available);
    status.innerHTML = available ? wrapper.dataset.hdInHtml : wrapper.dataset.hdOutHtml;
    status.style.color = available ? wrapper.dataset.hdInColor : wrapper.dataset.hdOutColor;

    var sticky = document.querySelector('.product-sticky-submit');
    if (sticky) {
      sticky.disabled = !available;
      sticky.setAttribute('aria-disabled', available ? 'false' : 'true');
      sticky.classList.toggle('is-disabled', !available);
    }
  }

  function installVariantFix() {
    if (!customElements.get('variant-selects')) return;
    var VariantSelectsClass = customElements.get('variant-selects');
    if (!VariantSelectsClass || VariantSelectsClass.prototype.hdAvailabilityPatched) return;
    VariantSelectsClass.prototype.hdAvailabilityPatched = true;

    VariantSelectsClass.prototype.toggleAddButton = function (disable = true, text, modifyClass = true) {
      var productForm = document.getElementById('product-form-' + this.dataset.section);
      if (!productForm) return;
      var addButton = productForm.querySelector('[name="add"]');
      var addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        addButton.setAttribute('aria-disabled', 'true');
        if (text && addButtonText) {
          addButtonText.textContent = text;
          setAvailability(this.dataset.section, false);
        }
      } else {
        addButton.removeAttribute('disabled');
        addButton.removeAttribute('aria-disabled');
        if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
        setAvailability(this.dataset.section, true);
      }

      if (!modifyClass) return;
    };

    var originalSetUnavailable = VariantSelectsClass.prototype.setUnavailable;
    VariantSelectsClass.prototype.setUnavailable = function () {
      if (originalSetUnavailable) originalSetUnavailable.call(this);
      setAvailability(this.dataset.section, false);
    };
  }

  customElements.whenDefined('variant-selects').then(installVariantFix).catch(function () {});

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="MainProduct-"]').forEach(function (main) {
      normalizeAvailability(main);
      var addButton = main.querySelector('.product-form__submit[name="add"]');
      if (addButton) {
        var sectionId = main.id.replace('MainProduct-', '');
        setAvailability(sectionId, !addButton.disabled);
      }
    });

    var sticky = document.querySelector('.product-sticky-submit');
    if (sticky) {
      sticky.addEventListener('click', function (event) {
        var mainButton = document.querySelector('.main-product__template .product-form__submit');
        if (!mainButton || mainButton.disabled || sticky.disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }
  });
})();
